export default __webpack_public_path__ + "static/media/companies_icon.846e0ada.svg";